import { DoorBehavior } from 'game/entities/bot/DoorBehavior';
import { DoorModule, ProcessPayload } from 'game/state/BotState';
import { Processor } from '../Processor';

export const doorProcessor: Processor<DoorModule> = (module, ctx) => {
  const { pwr } = module.inputs;
  const { modules } = ctx.bot.props.state;
  const pwrModule = pwr && modules.find(m => m.id === pwr.moduleId);
  if (!pwrModule) return { status: 'null' };
  const pwrResult = ctx.processOther(pwrModule, ctx);
  if (pwrResult.status !== 'success') return { status: 'null' };

  const payload: ProcessPayload = { type: 'command', action: 'open' };
  const opened = ctx.bot.entity.getFacet(DoorBehavior)?.open(ctx.delta);

  return opened
    ? { status: 'success', moduleId: module.id, value: payload }
    : { status: 'running', value: payload };
};
